import { IconFolderOutline18 } from "nucleo-ui-outline-18"

import { cn } from "@productlane/lib/src/browser"

import type { SuggestionProposal } from "./aggregate-proposals"

export const NO_FOLDER_LABEL = "No folder"

// Null while the folder loads, or once it is gone and accepting would supersede.
export function proposalFolderPath(
	proposal: Pick<SuggestionProposal, "proposedGroupId" | "proposedFolder">,
): string | null {
	if (!proposal.proposedGroupId) return NO_FOLDER_LABEL
	const folder = proposal.proposedFolder
	if (!folder) return null
	return folder.tabName ? `${folder.tabName} / ${folder.name}` : folder.name
}

export function ProposalFolder({
	proposal,
	className,
}: {
	proposal: Pick<SuggestionProposal, "proposedGroupId" | "proposedFolder">
	className?: string
}) {
	const path = proposalFolderPath(proposal)
	if (!path) return null
	return (
		<span
			data-testid="proposal-folder"
			title={path}
			className={cn(
				"flex min-w-0 items-center gap-1.5 text-gray-500 dark:text-gray-400",
				className,
			)}
		>
			<IconFolderOutline18 aria-hidden className="h-3.5 w-3.5 flex-none" />
			<span className="min-w-0 truncate">{path}</span>
		</span>
	)
}
